import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { OrderRepository } from '@/coreInfrastructureModule/Repositories/OrderRepository';
import { UpdateOrderAdapter } from '../adapters/UpdateOrderAdapter';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';

/**
 * 発注の更新を行うユースケース
 */
export class UpdateOrderUseCase {
  /**
   * 発注の編集を適用する
   * @param repository - リポジトリ
   * @param updateOrderRequests - 発注の編集に使用する項目
   */
  public static async execute(
    repository: OrderRepository,
    updateOrderRequests: CalendarOrder[]
  ): Promise<INetworkResult<undefined, IError>> {
    const response = await repository.update(UpdateOrderAdapter.adapt(updateOrderRequests));
    switch (response.status.type) {
      case 'success':
        return {
          status: {
            type: 'success',
            data: undefined,
          },
        };
      case 'error':
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
    }
  }
}
